// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/select/style/index.less
// module id = 1006
// module chunks = 1